import { resendOnboardingDocument } from 'commons/service/bank/onboardingDocuments'
import { WriteHook, useMutationManager } from 'state-manager'

export const useResendOnboardingDocument: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(resendOnboardingDocument, opts)
